export interface CrmOAuthState {
  provider: string;
  loginDomain?: string | null;
}

export const encodeCrmOAuthState = (state: CrmOAuthState): string => {
  return btoa(JSON.stringify(state));
};

export const decodeCrmOAuthState = (encodedState: string | null): CrmOAuthState | null => {
  if (!encodedState) {
    return null;
  }

  try {
    const parsedState = JSON.parse(atob(encodedState));

    if (!parsedState || typeof parsedState.provider !== 'string') {
      return null;
    }

    return {
      provider: parsedState.provider,
      loginDomain:
        typeof parsedState.loginDomain === 'string' && parsedState.loginDomain.trim()
          ? parsedState.loginDomain.trim()
          : null,
    };
  } catch {
    return null;
  }
};
